import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectPagesRoute: InvariantJiraRoute = {
	name: 'project-pages',
	path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages',
};
